import { NEWSLETTERS_SUBSCRIBE, returnOrThrow } from "./utils";

export const subscribeNewsletter = async (email) => {
  console.log("Subscribing to newsletter with email:", email);
  const resJSON = await fetch(NEWSLETTERS_SUBSCRIBE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email: email }),
  });
  const result = await returnOrThrow(resJSON);
  return result;
};
